// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1SBjO","footer":"ModalInfo_footer__1lU-m"};